import React from 'react';
import { Form, Input } from "antd";
import { Flex, Button, toast, RadioGroup, FlexItem } from '@chatui/core';
import UploadDragger from "../antdFormContent/uploadDragger";
import { ticketInfoReply, updateTicketSatisfaction } from '../../services/ticket';

const UserTicketTicketReply = props => {
    const { ticketData, getTicketInfoList } = props
    const [form] = Form.useForm();

    const submit = () => {
        form
            .validateFields()
            .then((values) => {
                console.log(values)
                let file_url = "";
                if (values.file) {
                    const fileList = values.file.filter(i => i.response && i.response.code === 0).map(i => { return i.response.data.url })
                    if (fileList.length > 0) {
                        file_url = fileList[0]
                    }
                }
            
                ticketInfoReply({
                    id: ticketData.id,
                    content: values.content,
                    file_url: file_url,
                    account: ticketData.account,
                })
                    .then(res => {
                        if (res.code === 0 && res.data.code === 0) {
                            form.resetFields();
                            toast.success("回复成功")
                            getTicketInfoList()
                        } else {
                            toast.show(res.data.message || res.msg)
                        }
                    })
            })
    }

    return <Form form={form}>
        <Form.Item
            name={'content'}
            rules={[{ required: true, message: '请输入回复信息' }]}
        >
            <Input placeholder={'输入回复信息'} />
        </Form.Item>
        <Form.Item
            name={'file'}
            valuePropName="fileList"
            getValueFromEvent={(e) => {
                if (Array.isArray(e)) { return e; }
                return e && e.fileList;
            }}
        >
            <UploadDragger accept="image/*" listType="picture" maxCount={1} placeholder="上传图片,格式png,jpg,gif" />
        </Form.Item>
        <Flex center style={{ paddingTop: "20px" }}>
            <Button color="primary" style={{ maxWidth: '400px', width: '100%' }} onClick={submit}>提交回复</Button>
        </Flex>
    </Form>
}

const UserTicketSatisfaction = (props) => {
    const { ticketData, getTicket } = props;
    const [form] = Form.useForm();

    const submit = () => {
        form
            .validateFields()
            .then((values) => {
                updateTicketSatisfaction({
                    id: ticketData.id,
                    csi: values.csi,
                    resolved: values.resolved,
                    account: ticketData.account,
                })
                    .then(res => {
                        if (res.code === 0 && res.data.code === 0) {
                            form.resetFields();
                            toast.success("评价成功")
                            getTicket()
                        } else {
                            toast.show(res.data.message || res.msg)
                        }
                    })
            })
    }

    const resolvedOptions = [
        { label: '已解决', value: 1 },
        { label: '未解决', value: 0 },
    ];
    const csiOptions = [
        { label: '非常满意', value: 5 },
        { label: '满意', value: 4 },
        { label: '一般', value: 3 },
        { label: '不满意', value: 2 },
        { label: '非常不满意', value: 1 },
    ];

    return <Form form={form}>
        <Form.Item
            label="本次事件处理是否解决了您的问题"
            name={'resolved'}
            rules={[{ required: true, message: '请选择处理反馈' }]}
        >
            <RadioGroup options={resolvedOptions} />
        </Form.Item>
        <Form.Item
            label="请问您对本次服务是否满意"
            name={'csi'}
            rules={[{ required: true, message: '请选择满意度' }]}
        >
            <RadioGroup options={csiOptions} />
        </Form.Item>
        <Flex center style={{ paddingTop: "20px" }}>
            <Button color="primary" style={{ maxWidth: '400px', width: '100%' }} onClick={submit}>提交</Button>
        </Flex>
    </Form>
}

const TicketFeedback = (ticketData, getTicket, getTicketInfoList) => {
    const status = Number(ticketData.status);
    if (status === 0 || status === 1) {  // 0待处理 1处理中
        return <>
            <FlexItem style={{ marginLeft: '0.75em', marginTop: '1em', paddingLeft: '12px', borderStyle: 'none none none solid', borderColor: "var(--brand-1)", borderWidth: '4px' }}>信息反馈</FlexItem>
            <FlexItem style={{ marginLeft: '0.75em', marginTop: '1em', paddingLeft: '12px', }}>
                <UserTicketTicketReply ticketData={ticketData} getTicketInfoList={getTicketInfoList} />
            </FlexItem>
        </>
    } else if (status === 2) {  // 2待评价
        return <>
            <FlexItem style={{ marginLeft: '0.75em', marginTop: '1em', paddingLeft: '12px', borderStyle: 'none none none solid', borderColor: "var(--brand-1)", borderWidth: '4px' }}>提交评价</FlexItem>
            <FlexItem style={{ marginLeft: '0.75em', marginTop: '1em', paddingLeft: '12px', }}>
                <UserTicketSatisfaction ticketData={ticketData} getTicket={getTicket} />
            </FlexItem>
        </>
    } else {                    // 3已结单
        return null
    }
}

export default TicketFeedback;
